import styled from "styled-components";

import { EmptyState } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { ECategoryLeadersMetricType } from "../category-leaders/CategoryLeaders.types";

import { WebsiteRankingsTabs } from "./WebsiteRankingsTabs";

const BlankStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 64px 24px;
    text-align: center;
`;

export const WebsiteRankingsStartPage = () => {
    const t = useTranslation();

    return (
        <FlexColumn gap="24px">
            <WebsiteRankingsTabs selectedTabId={ECategoryLeadersMetricType.CategoryLeadersAll} />
            <BlankStateContainer>
                <EmptyState
                    iconName="company-empty-suggestions"
                    title={t("industry.research.website.rankings.start.page.title")}
                    subtitle={t("industry.research.website.rankings.start.page.subtitle")}
                />
            </BlankStateContainer>
        </FlexColumn>
    );
};
